<template>
  <v-container fluid class="fill-height d-flex align-center justify-center">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
    <p class="ml-4">Redirigiendo a la nueva plataforma...</p>
  </v-container>
</template>

<script>
import { onMounted } from "vue";

export default {
  name: "VistaPublica",
  setup() {
    onMounted(() => {
      // 1. Capturamos los parámetros actuales (ej: ?mac=AST...)
      const params = window.location.search;

      // 2. Definimos la nueva base
      const newDomain = "https://app.prod.axia-monitoring.com/public";

      // 3. Ejecutamos la redirección
      // Usamos .replace para que el usuario no pueda volver atrás a esta página de "carga"
      window.location.replace(`${newDomain}${params}`);
    });

    return {};
  },
};
</script>

<style scoped>
/* Estilos mínimos para el mensaje de carga */
p {
  font-family: sans-serif;
  color: #666;
}
</style>
